import { AbstractControl, ValidationErrors } from '@angular/forms';

// Custom Validator for Email Subject
export function emailSubjectValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (!value) {
    return null;
  }

  const errors: any = {};
  let hasError = false;

  // 1. Check for all uppercase letters (if length > 5)
  if (value.length > 5 && value === value.toUpperCase() && /[a-zA-Z]/.test(value)) {
    errors.allCaps = true;
    hasError = true;
  }

  // 2. Check for continuous excessive punctuation (!!!, ???, $$$)
  if (/([!?.@#$%^&*]){3,}/.test(value)) {
    errors.excessivePunctuation = true;
    hasError = true;
  }

  // 3. Check for specific spam triggers (case-insensitive)
const spamTriggers = [
  '$$$', '100% free', '100% guaranteed', '100% satisfied',
  'make money', 'earn money', 'earn extra cash', 'earn $',
  'get rich', 'quick cash', 'fast cash', 'cash bonus',
  'double your income', 'financial freedom', 'income opportunity',
  'work from home', 'be your own boss', 'earn per day',
  'instant income', 'no investment required', 'risk-free',
  'risk free', 'guaranteed income', 'millionaire',
  'passive income', 'unlimited income', 'extra income',
  'easy money', 'make $', 'profit now', 'crypto profit',
  'forex signals', 'investment opportunity',
  'no experience required',

  'limited time', 'limited time offer', 'act now', 'act fast',
  'exclusive deal', 'exclusive offer', 'special promotion',
  'special deal', 'today only', 'offer expires',
  'last chance', 'don\'t miss out', 'free gift',
  'free trial', 'free access', 'free bonus',
  'buy now', 'apply now', 'order now',
  'call now', 'click here', 'click below',
  'sign up now', 'instant access',
  'save big', 'huge discount', 'lowest price',
  'best price', 'clearance sale', 'cheap',
  'discounted', 'bonus offer', 'one time offer',
  'deal of the day',

  'winner', 'you won', 'congratulations',
  'claim your prize', 'claim now', 'lottery winner',
  'jackpot', 'selected winner', 'free entry',
  'prize alert', 'cash prize', 'reward waiting',
  'winning notification',

  'urgent', 'urgent!', 'immediate action required',
  'respond immediately', 'final notice',
  'account suspended', 'verify now',
  'limited availability', 'expires soon',
  'hurry up', 'important notice',
  'time sensitive', 'security alert',
  'unusual activity',

  'viagra', 'cialis', 'adult content',
  'xxx', 'score with babes',
  'dating hot singles', 'escort',
  'casino', 'betting', 'gambling',
  'no prescription', 'pharmacy',
  'miracle cure', 'weight loss secret',

  'no hidden fees', 'pre-approved',
  'credit check', 'loan approval',
  'instant loan', 'bad credit',
  'refinance now', 'debt free',
  'consolidate debt', 'low interest',
  'apply for loan', 'credit card offer',
  'zero interest',

  '!!!', '???', 'free!!!',
  'act now!!!', 'visit link',
  'open immediately'
];

  const lowerValue = value.toLowerCase();
  const foundTriggers = spamTriggers.filter(trigger => lowerValue.includes(trigger.toLowerCase()));

  if (foundTriggers.length > 0) {
    errors.spamTriggers = foundTriggers;
    hasError = true;
  }

  // 4. Minimum length check
  if (value.trim().length < 5) {
    errors.minLengthError = true;
    hasError = true;
  }

  return hasError ? errors : null;
}
